/**
 * 检测数据是否为 String 类型
 * ========================================================================
 * @method isArray
 * @param {*} str
 * @returns {boolean}
 */
const isString = (str) => {
  return typeof str === 'string'
}

export default isString
